import React, {useEffect, useRef, useState} from 'react';
import {IonHeader, IonPage} from '@ionic/react';
import {useTranslation} from 'react-i18next';
import {useLocation} from "react-router-dom";

import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from '@components/content/content.style';
import TravelAllowanceSubMenuModal from "@modals/menu/travelAllowanceSubMenu.component";
import HelpdeskSubMenuModal from "@modals/menu/helpdeskSubMenu.component";

const SubMenuPage: React.FC = () => {
    const {t} = useTranslation();
    const location = useLocation();
    const header = useRef<HTMLIonHeaderElement>(null);

    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);

    useEffect(() => {
        updateHeight();
    });

    const updateHeight = () => {
        if (header.current?.clientHeight === 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const getTitle = () => {
        switch (location.pathname) {
            case '/main/travel-allowance':
                return t('travelAllowance.subMenu.title');
            case '/main/helpdesk':
                return t('helpdesk.subMenu.title');
            default:
                return '';
        }
    }

    const renderSubMenuModal = () => {
        switch (location.pathname) {
            case '/main/travel-allowance':
                return <TravelAllowanceSubMenuModal topEdge={topEdge}/>;
            case '/main/helpdesk':
                return <HelpdeskSubMenuModal topEdge={topEdge}/>;
            default:
                return null;
        }
    };

    return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <StyledIonTitle>{getTitle()}</StyledIonTitle>
                    </StyledIonToolbar>
                </IonHeader>
                {renderSubMenuModal()}
            </StyledIonContent>
        </IonPage>
    );
};

export default SubMenuPage;